export default __webpack_public_path__ + "static/media/alfaRomeo.1507e8f7.png";